import { useIsAuthenticated } from "@azure/msal-react";
import { useCallback, useEffect, useState } from "react";
import {
  getSituation,
  SituationModel,
} from "../../clients/BackOfficeApi";
import { useParams } from "react-router-dom";
import { Box, Flex, Heading, Spinner, Text } from "@chakra-ui/react";
import { SituationActions } from "../../components/SituationContent/SituationActions";
import { DetailPageHeader } from "../../compositions/DetailPageHeader";
import { LinkButton } from "../../elements/LinkButton";
import { ScenarioTable } from "../../components/ScenarioContent/ScenarioTable";
import { VisibilityIcon } from "../../elements/VisibilityIcon";

export function SituationDetailPage() {
  const situationId = Number(useParams().situationId);
  const [error, setError] = useState<string>();
  const isAuthenticated = useIsAuthenticated();

  const [loading, setLoading] = useState(true);

  const [situation, setSituation] = useState<SituationModel>();

  const fetchSituation = useCallback(
    async (signal?: AbortSignal) => {
      if (!isAuthenticated) return;

      setError(undefined);
      setLoading(true);

      if (!Number.isInteger(situationId) || situationId <= 0) {
        setError("Ongeldig situatie ID");
        setLoading(false);
        return;
      }

      getSituation({
        path: { situationId },
        signal,
        throwOnError: true,
      })
        .then(({ data }) => {
          setSituation(data);
        })
        .catch((e) => {
          if (signal?.aborted) return;

          setError(`Fout bij ophalen situatie: ${e.message ?? String(e)}`);
        })
        .finally(() => setLoading(false));
    },
    [isAuthenticated, situationId],
  );

  useEffect(() => {
    const abortController = new AbortController();

    fetchSituation(abortController.signal);

    return () => abortController.abort("Component unmounted or re-rendered");
  }, [fetchSituation]);

  return (
    <Box>
      <DetailPageHeader>
        {!!situation && (
          <SituationActions onChange={fetchSituation} situation={situation} />
        )}
      </DetailPageHeader>
      {loading && <Spinner />}
      {error && <Text color="red.500">{error}</Text>}
      {!!situation && (
        <>
          <Heading>
            Situatie: {situation.residenceTypeName} | {situation.orientation} |{" "}
            {situation.relativePosition}
          </Heading>
          <Box>
            <Text>
              WoningType:{" "}
              <LinkButton to={`/residence-types/${situation.residenceTypeId}`}>
                {situation.residenceTypeName}
              </LinkButton>
            </Text>
            <Text>Situatie ID: {situation.id}</Text>
            <Text>Orientatie: {situation.orientation}</Text>
            <Text>Positie: {situation.relativePosition}</Text>
            <Flex gap={2}>
              <Text>Status:</Text>
              <VisibilityIcon visibility={situation.visibility} />
            </Flex>
          </Box>
          <ScenarioTable situationId={situationId} />
        </>
      )}
    </Box>
  );
}
